import React from 'react';
import { Card, CardContent } from '../ui/card';

export const StatCard = ({ title, value, icon: Icon, color = "primary", className = "" }) => (
  <Card className={`glass-effect border-white/10 ${className}`}>
    <CardContent className="p-4 sm:p-6">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs sm:text-sm text-muted-foreground truncate">{title}</p>
          <p className="text-xl sm:text-2xl lg:text-3xl font-bold mt-0.5 sm:mt-1">{value}</p>
        </div>
        <div className={`p-2 sm:p-3 rounded-full bg-${color}/20 flex-shrink-0`}>
          <Icon className={`h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6 text-${color}`} />
        </div>
      </div>
    </CardContent>
  </Card>
);
